<template>
  <div ref="dressCodeRef" class="dresscode-container"> 
    <!-- Línea y título Dress Code animado -->
    <div ref="line1Ref" class="animated-line"></div>
    <div ref="dressCodeText" class="dresscode-title">DRESS CODE</div>

    <!-- Icono -->
    <img ref="iconRef" src="../assets/formal.svg" alt="Percha" class="vestimenta-icon" />

    <!-- Texto -->
    <div ref="text2Ref" class="text2">Formal    <br>Reservamos el color rojo para la quinceañera.</div>

    <div ref="line2Ref" class="animated-line"></div>

    <!-- Regalos -->
    <div ref="regalosRef" class="dresscode-title">Regalos</div>
    <img ref="iconoRegaloRef" src="@/assets/sonrte-dor.png" alt="Icono regalo" class="vestimenta-icon" />
    <div ref="mesaRef" class="text2">Mesa 16</div>

    <!-- Separador floral -->
    <img
      ref="separadorRef"
      src="@/assets/separador.png"
      alt="Separador floral"
      class="separador-final"
    />
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'DressCodeSection',
  setup() {
    const dressCodeRef = ref(null);
    const dressCodeText = ref(null);
    const line1Ref = ref(null);
    const iconRef = ref(null);
    const text2Ref = ref(null);
    const line2Ref = ref(null);
    const separadorRef = ref(null);
    const regalosRef = ref(null);
    const iconoRegaloRef = ref(null);
    const mesaRef = ref(null);

    const animateElements = () => {
      gsap.fromTo(line1Ref.value, { width: 0 }, { width: "100%", duration: 1.5, ease: "power2.out" });
      gsap.fromTo(dressCodeText.value, { opacity: 0, x: -50 }, { opacity: 1, x: 0, duration: 1.2, ease: "power3.out", delay: 0.3 });
      gsap.fromTo(iconRef.value, { opacity: 0, scale: 0.7 }, { opacity: 1, scale: 1, duration: 1.2, ease: "power3.out", delay: 0.6 });
      gsap.fromTo(text2Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, ease: "power3.out", delay: 0.9 });
      gsap.fromTo(line2Ref.value, { width: 0 }, { width: "100%", duration: 1.5, ease: "power2.out", delay: 1.2 });

      gsap.fromTo(regalosRef.value, { x: -60, opacity: 0 }, { x: 0, opacity: 1, duration: 1.2, ease: "back.out(1.7)", delay: 1.5 });
      gsap.fromTo(iconoRegaloRef.value, { scale: 0.3, opacity: 0 }, { scale: 1, opacity: 1, duration: 1.4, ease: "elastic.out(1, 0.3)", delay: 1.8 });
      gsap.fromTo(mesaRef.value, { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1.3, ease: "power2.out", delay: 2.1 });

      gsap.fromTo(separadorRef.value, { y: 50, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out",
        delay: 2.4
      });
    };

    onMounted(() => {
      nextTick(() => {
        ScrollTrigger.create({
          trigger: dressCodeRef.value,
          start: "top 85%",
          toggleActions: "play none none reset",
          onEnter: animateElements,
          onEnterBack: animateElements,
        });
      });
    });

    return {
      dressCodeRef,
      dressCodeText,
      line1Ref,
      iconRef,
      text2Ref,
      line2Ref,
      separadorRef,
      regalosRef,
      iconoRegaloRef,
      mesaRef
    };
  }
};
</script>

<style scoped>
.dresscode-container {
  text-align: center;
  padding: 0px 0px 0;
  max-width: 600px;
  margin: -20px auto 0;
  position: relative;
  background-color: transparent;
}

.animated-line {
  width: 0;
  height: 2px;
  background-color: #fefefe;
  margin: 20px auto;
}

.dresscode-title {
  font-size: 24px;
  font-family: 'Playfair Display', serif;
  font-weight: bold;
  color: #f1e9ea;
  text-transform: uppercase;
  opacity: 0;
}

.vestimenta-icon {
  width: 105px;
  height: auto;
  margin: 25px 0;
  opacity: 0;
}

.text2 {
  font-size: 19px;
  font-family: "Hearth Stone", sans-serif;
  font-weight: 500;
  color: #e3e0e0;
  margin-top: 10px;
  opacity: 0;
}

.separador-final {
  width: 50%;
  max-width: 300px;
  height: auto;
  display: block;
  margin: 0 auto;
  padding: 0;
  opacity: 0;
  transform: translateY(50px);
}
</style>
